import PropTypes from "prop-types";

NoteProxyInfo.propTypes = {
  receivedViaProxyUsers: PropTypes.array.isRequired,
};

export default function NoteProxyInfo({ receivedViaProxyUsers }) {
  if (
    !receivedViaProxyUsers ||
    !Array.isArray(receivedViaProxyUsers) ||
    receivedViaProxyUsers.length === 0
  )
    return null;

  const getDisplayText = () => {
    if (receivedViaProxyUsers.length === 1) {
      return `Received as a proxy contact for ${receivedViaProxyUsers[0].fullName}`;
    } else if (receivedViaProxyUsers.length === 2) {
      return `Received as a proxy contact for ${receivedViaProxyUsers[0].fullName} & ${receivedViaProxyUsers[1].fullName}`;
    } else {
      return `Received as a proxy contact for ${receivedViaProxyUsers
        .map((user) => user.fullName)
        .join(", ")}`;
    }
  };

  return (
    <div>
      <span>•</span> {getDisplayText()}
    </div>
  );
}
